import React, { useEffect, useState } from "react";
import { IoSettingsOutline } from "react-icons/io5";
import RightDrawer from "../../component/RightDrawer";
import AccrodianBox from "../../component/AccrodianBox";
import InputField from "../../component/InputField";
import ButtonCompo from "../../component/ButtonCompo";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import { Checkbox, LinearProgress } from "@mui/material";
import AlertBox from "../../component/AlertBox";
import DialogBox from "../../component/DialogBox";
import { FiAlertCircle } from "react-icons/fi";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { WordLimitIndicator } from "../../utils/WordLimitIndicator";
import { useSelector } from "react-redux";

function Config({
  offerLetterTemplate,
  setReload,
  termsAndCond,
  actionButton,
}) {
  const [enableTemplateSaveButton, setEnableTemplateSaveButton] =
    useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [offerLetterTermsAndCond, setOfferLetterTermsAndCond] = useState([]);
  const [configReload, setConfigReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedDesc, setSelectedDesc] = useState("");
  const { letterName } = useParams();

  // set default values
  useEffect(() => {
    setSelectedTemplate(offerLetterTemplate);
    setOfferLetterTermsAndCond(termsAndCond);
  }, [offerLetterTemplate, termsAndCond]);

  //edit generate offer letter template
  async function editOfferLetterTemplate() {
    const data = {
      offerLetterText: selectedTemplate,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/update/company`,
        method: "put",
        withCredentials: true,
        data: data,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Template updated successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(false);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Template update failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  //add policy
  async function addPolicy() {
    if (selectedTitle?.length === 0 || selectedDesc?.length === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please fill all the fields");
      return null;
    }
    const data = {
      title: selectedTitle,
      description: selectedDesc,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/offer/letter/policy/add`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Policy added successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Policy added failed");
      console.log(error);
    } finally {
      setSelectedDesc("");
      setSelectedTitle("");
      setLoading(false);
    }
  }

  //edit policy
  async function editPolicy(policyId) {
    const data = {
      title: selectedTitle,
      description: selectedDesc,
      policyId: policyId,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/offer/letter/policy/edit`,
        method: "put",
        withCredentials: true,
        data: data,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Policy edited successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Policy edit failed");
      console.log(error);
    } finally {
      setLoading(false);
      setSelectedDesc("");
      setSelectedTitle("");
    }
  }

  //delete policy
  async function deletePolicy(policyId) {
    console.log("hi");
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/offer/letter/policy/delete`,
        method: "delete",
        withCredentials: true,
        data: {
          policyId: policyId,
        },
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Policy deleted successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Policy delete failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // set prev value
  function setValue(data) {
    setSelectedTitle(data?.title);
    setSelectedDesc(data?.description);
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px] !z-[100000000]" />
      )}
      {success && (
        <AlertBox
          open={open}
          setOpen={setOpen}
          success={success}
          title={message}
        />
      )}
      {!success && (
        <AlertBox
          open={open}
          setOpen={setOpen}
          success={success}
          title={message}
        />
      )}
      <RightDrawer actionButton={actionButton} width="50">
        <div>
          <div className="w-full p-5" onClick={(eve) => eve.stopPropagation()}>
            <h2 className="font-semibold text-center text-[18px]">
              Letter Configurations
            </h2>
            <div className="mt-5">
              {letterName === "Offer Letter" && (
                <AccrodianBox title={"Offer Letter Template"}>
                  <InputField
                    label="Template"
                    multiline
                    value={selectedTemplate}
                    rows={15}
                    onChange={(eve) => {
                      setEnableTemplateSaveButton(true);
                      setSelectedTemplate(eve?.target?.value);
                    }}
                  />
                  {enableTemplateSaveButton && (
                    <div className="flex justify-end mt-5">
                      <ButtonCompo
                        variant={"contained"}
                        onClick={editOfferLetterTemplate}
                      >
                        Save Changes
                      </ButtonCompo>
                    </div>
                  )}
                </AccrodianBox>
              )}
              <AccrodianBox title={"Terms & Conditions"}>
                {offerLetterTermsAndCond?.length > 0 ? (
                  <div>
                    <div className="flex justify-end">
                      <DialogBox
                        trigger={<ButtonCompo>Add T&C</ButtonCompo>}
                        title="New T&C"
                        actionButton={
                          <ButtonCompo onClick={addPolicy}>Save</ButtonCompo>
                        }
                      >
                        <div className="space-y-3">
                          <InputField
                            label="Title"
                            value={selectedTitle}
                            onChange={(eve) =>
                              setSelectedTitle(eve?.target?.value)
                            }
                            required
                          />
                          <InputField
                            label="Description"
                            value={selectedDesc}
                            onChange={(eve) =>
                              setSelectedDesc(eve?.target?.value)
                            }
                            required
                            multiline
                          />
                        </div>
                      </DialogBox>
                    </div>
                    {offerLetterTermsAndCond?.map((tcData, i) => (
                      <section>
                        <section className="mt-3">
                          <p className="text-slate-500">
                            <span className="text-slate-700 font-semibold">
                              {tcData?.title}
                            </span>{" "}
                            {tcData?.description}
                          </p>
                          <section className="mt-3 flex items-center gap-3 justify-end">
                            <DialogBox
                              trigger={
                                <ButtonCompo onClick={() => setValue(tcData)}>
                                  Edit
                                </ButtonCompo>
                              }
                              title="New T&C"
                              actionButton={
                                <ButtonCompo
                                  onClick={() => editPolicy(tcData?.policyId)}
                                >
                                  Save
                                </ButtonCompo>
                              }
                            >
                              <div className="space-y-3">
                                <InputField
                                  label="Title"
                                  value={selectedTitle}
                                  onChange={(eve) =>
                                    setSelectedTitle(eve?.target?.value)
                                  }
                                  required
                                />
                                <InputField
                                  label="Description"
                                  value={selectedDesc}
                                  onChange={(eve) =>
                                    setSelectedDesc(eve?.target?.value)
                                  }
                                  required
                                  multiline
                                />
                              </div>
                            </DialogBox>
                            <ButtonCompo
                              color={"error"}
                              onClick={() => deletePolicy(tcData?.policyId)}
                            >
                              Delete
                            </ButtonCompo>
                          </section>
                        </section>
                      </section>
                    ))}
                  </div>
                ) : (
                  <div>
                    <p className="text-center text-slate-500 font-medium">
                      No terms and conditions added yet
                    </p>
                    <section className="flex justify-center items-center">
                      <DialogBox
                        trigger={<ButtonCompo>Add T&C</ButtonCompo>}
                        title="New T&C"
                        actionButton={
                          <ButtonCompo onClick={addPolicy}>Save</ButtonCompo>
                        }
                      >
                        <div className="space-y-3">
                          <InputField
                            label="Title"
                            value={selectedTitle}
                            onChange={(eve) =>
                              setSelectedTitle(eve?.target?.value)
                            }
                            required
                          />
                          <InputField
                            label="Description"
                            value={selectedDesc}
                            onChange={(eve) =>
                              setSelectedDesc(eve?.target?.value)
                            }
                            required
                            multiline
                          />
                        </div>
                      </DialogBox>
                    </section>
                  </div>
                )}
              </AccrodianBox>
            </div>
          </div>
        </div>
      </RightDrawer>
    </>
  );
}

function OfferLetter() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector((state) => state.employee?.employeeData);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.letterGenerate === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedOfferLetterTemplate, setSelectedOfferLetterTemplate] =
    useState("");
  const [offerLetterTermsAndCond, setOfferLetterTermsAndCond] = useState([]);
  const [editedOfferLetter, setEditedOfferLetter] = useState("");
  const [editedTermsAndCond, setEditedTermsAndCond] = useState([]);
  const [selectedYS, setSelectedYS] = useState("");
  const [selectedDesig, setSelectedDesig] = useState("");
  const [salaryStructure, setSalaryStructure] = useState([]);
  const [selectedCtc, setSelectedCtc] = useState(0);
  const [selectedBasic, setSelectedBasic] = useState(0);
  const [inHand, setInhand] = useState(0);
  const [pdfLink, setPdfLink] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedTAndC, setSelectedTAndC] = useState([]);
  // flag for word limit
  const [letterHeadingFlag, setLetterHeadingFlag] = useState(true);
  const [letterContentFlag, setLetterContentFlag] = useState(true);
  // customization
  const { letterName } = useParams();
  const [searchParams] = useSearchParams()
  const applicantId = searchParams.get("applicantId");
  const emailId = searchParams.get("emailId");

  // select letter title
  useEffect(() => {
    if (letterName !== "Custom Letter") {
      setSelectedTitle(letterName || "");
    } else {
      setSelectedTitle("");
    }
  }, [letterName]);

  async function getCompanyData() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/company/data`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setSelectedOfferLetterTemplate(res.data?.data?.offerLetterText || "");
      setOfferLetterTermsAndCond(res.data?.data?.offerLetterPolicies || []);
      // direct offer letter edit
      if (letterName === "Offer Letter") {
        setEditedOfferLetter(res.data?.data?.offerLetterText || "");
      }
      setEditedTermsAndCond(res.data?.data?.offerLetterPolicies || []);
      setSalaryStructure(res.data?.data?.salaryStructure);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // generate offer letter
  async function generateOfferLetter() {
    if (
      selectedTitle?.length === 0 ||
      editedOfferLetter?.length === 0 ||
      selectedYS?.length === 0 ||
      selectedDesig?.length === 0
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please complete the STEP 1");
      return null;
    }
    if (
      selectedBasic?.length <= 0 ||
      selectedCtc?.length <= 0 ||
      inHand <= 0 ||
      salaryStructure?.length === 0
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage(
        "Please complete the STEP 2. Add at least 1 field in salary structure except basic, ctc and in-hand."
      );
      return null;
    }
    const data = {
      template: editedOfferLetter,
      sender: selectedYS,
      designation: selectedDesig,
      salaryStructure: salaryStructure,
      ctc: selectedCtc,
      basic: selectedBasic,
      inHand: inHand,
      termsAndCond: selectedTAndC,
      title: selectedTitle,
      applicantId: applicantId || "",
      emailId: emailId || "",
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/generate/letter/offer`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Offer letter generated successfully");
        setPdfLink(res.data?.data);
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(
        error?.response?.data?.message || "Offer letter generate failed"
      );
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // update user salary structure value
  const handleChangeSalary = (index, value) => {
    setSalaryStructure((prev) => {
      let newArr = [...prev];

      newArr[index] = { ...newArr[index], amount: Number(value) };

      return newArr;
    });
  };

  // terms and condition array ops
  function handleChangeTAndCArray(status, data) {
    if (status) {
      setSelectedTAndC((prev) => [...prev, data]);
    } else {
      setSelectedTAndC((prev) => {
        const newArr = prev.filter((opt) => opt?.policyId !== data?.policyId);
        return newArr;
      });
    }
  }

  useEffect(() => {
    getCompanyData();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <section>
            <section className="flex justify-between items-center">
              <h1 className="text-[30px] font-medium text-left w-full">
                Generate {letterName}
              </h1>
              <Config
                offerLetterTemplate={selectedOfferLetterTemplate}
                setReload={setReload}
                termsAndCond={offerLetterTermsAndCond}
                actionButton={
                  <section className="flex items-center gap-2 bg-slate-100 p-3 rounded-[10px] cursor-pointer hover:bg-slate-200/50">
                    <IoSettingsOutline className="text-[20px] text-slate-500" />
                    <p className="text-slate-700">Configurations</p>
                  </section>
                }
              />
            </section>
            {letterName === "Custom Letter" && (
              <section className="flex items-center gap-1 my-3">
                <FaCheckCircle size={20} className="text-green-500" />
                <p className="text-slate-700">
                  Generate any{" "}
                  <span className="font-medium">salary table-based letter</span>{" "}
                  from here. E.g, Offer letter, Hike letter etc.
                </p>
              </section>
            )}
          </section>
          <div className="w-full mt-5">
            <div>
              <AccrodianBox
                title={
                  <p className="text-slate-800 font-medium">
                    <span className="bg-slate-200 text-slate-600 py-2 px-3 font-semibold rounded-full text-[15px]">
                      STEP 1
                    </span>{" "}
                    <span
                      className={
                        letterHeadingFlag === false ||
                        letterContentFlag === false
                          ? "text-red-600 font-medium"
                          : "text-slate-700 font-medium"
                      }
                    >
                      Template Settings
                    </span>
                  </p>
                }
                id={1}
                defaultExpanded
              >
                <div className="space-y-3">
                  <section>
                    {selectedTitle.length > 0 && (
                      <section className="flex justify-end">
                        <WordLimitIndicator
                          limit={50}
                          words={selectedTitle}
                          setFlag={setLetterHeadingFlag}
                        />
                      </section>
                    )}
                    <InputField
                      label="Title"
                      onChange={(eve) => setSelectedTitle(eve?.target?.value)}
                      required
                      color={letterHeadingFlag === true ? "" : "error"}
                      value={selectedTitle}
                    />
                  </section>
                  <section>
                    {editedOfferLetter.length > 0 && (
                      <section className="flex justify-end">
                        <WordLimitIndicator
                          limit={4000}
                          words={editedOfferLetter}
                          setFlag={setLetterContentFlag}
                        />
                      </section>
                    )}
                    <InputField
                      value={editedOfferLetter}
                      multiline
                      rows={20}
                      label="Template"
                      onChange={(eve) =>
                        setEditedOfferLetter(eve?.target?.value)
                      }
                      color={letterContentFlag === true ? "" : "error"}
                    />
                  </section>
                  <section className="grid grid-cols-2 gap-5">
                    <InputField
                      label="Your Sincerely"
                      onChange={(eve) => setSelectedYS(eve?.target?.value)}
                      required
                    />
                    <InputField
                      label="Designation"
                      onChange={(eve) => setSelectedDesig(eve?.target?.value)}
                      required
                    />
                  </section>
                </div>
              </AccrodianBox>
              <AccrodianBox
                title={
                  <p className="text-slate-800 font-medium">
                    <span className="bg-slate-200 text-slate-600 py-2 px-3 font-semibold rounded-full text-[15px]">
                      STEP 2
                    </span>{" "}
                    Salary Structure Settings
                  </p>
                }
                id={2}
              >
                <div className="mt-5 w-full">
                  <div>
                    <div>
                      <h2 className="font-semibold w-fit pl-2 text-slate-700">
                        CTC Fields
                      </h2>
                      <div className="mt-5 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                        <InputField
                          label={"CTC"}
                          onChange={(e) => setSelectedCtc(e?.target?.value)}
                          value={selectedCtc}
                        />
                        {salaryStructure?.map((e, i) =>
                          e?.isDeduction !== true ? (
                            <InputField
                              label={e?.name}
                              onChange={(e) =>
                                handleChangeSalary(i, e?.target?.value)
                              }
                              value={e?.amount}
                              key={i}
                            />
                          ) : (
                            ""
                          )
                        )}
                        <InputField
                          label={"Basic"}
                          onChange={(evt) =>
                            setSelectedBasic(evt?.target?.value)
                          }
                          value={selectedBasic}
                        />
                        <InputField
                          label={"In Hand"}
                          onChange={(evt) => setInhand(evt?.target?.value)}
                          value={inHand}
                        />
                      </div>
                    </div>
                    <div className="mt-5">
                      <h2 className="font-semibold w-fit text-slate-700">
                        Deduction Fields
                      </h2>
                      <div className="mt-5 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                        {salaryStructure?.map((e, i) =>
                          e?.isDeduction === true ? (
                            <InputField
                              label={e?.name}
                              onChange={(e) =>
                                handleChangeSalary(i, e?.target?.value)
                              }
                              value={e?.amount}
                              key={i}
                            />
                          ) : (
                            ""
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </AccrodianBox>
              <AccrodianBox
                title={
                  <p className="text-slate-800 font-medium">
                    <span className="bg-slate-200 text-slate-600 py-2 px-3 font-semibold rounded-full text-[15px]">
                      STEP 3
                    </span>{" "}
                    Terms & Conditions
                  </p>
                }
                id={3}
              >
                {editedTermsAndCond?.length > 0 ? (
                  <div>
                    <div className="flex justify-end">
                      <Config
                        offerLetterTemplate={selectedOfferLetterTemplate}
                        setReload={setReload}
                        termsAndCond={offerLetterTermsAndCond}
                        actionButton={<ButtonCompo>Add T&C</ButtonCompo>}
                      />
                    </div>
                    {offerLetterTermsAndCond?.map((tcData, i) => (
                      <section key={i}>
                        <section className="mt-3">
                          <section className="text-slate-500 flex items-center">
                            <span className="text-slate-700 font-semibold">
                              <Checkbox
                                onChange={(event) =>
                                  handleChangeTAndCArray(
                                    event?.target?.checked,
                                    tcData
                                  )
                                }
                              />
                            </span>{" "}
                            <div>
                              <span className="text-slate-700 font-semibold">
                                {tcData?.title}
                              </span>{" "}
                              {tcData?.description}
                            </div>
                          </section>
                        </section>
                      </section>
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-col justify-center items-center gap-5">
                    <p className="text-center text-slate-500 font-medium">
                      No terms and conditions added yet
                    </p>
                    <Config
                      offerLetterTemplate={selectedOfferLetterTemplate}
                      setReload={setReload}
                      termsAndCond={offerLetterTermsAndCond}
                      actionButton={
                        <section className="flex items-center gap-2 bg-slate-100 p-3 rounded-[10px] cursor-pointer hover:bg-slate-200/50">
                          <IoSettingsOutline className="text-[20px] text-slate-500" />
                          <p className="text-slate-700">Configurations</p>
                        </section>
                      }
                    />
                  </div>
                )}
              </AccrodianBox>
              <AccrodianBox
                title={
                  <p className="text-slate-800 font-medium">
                    <span className="bg-slate-200 text-slate-600 py-2 px-3 font-semibold rounded-full text-[15px]">
                      STEP 4
                    </span>{" "}
                    Generate Offer Letter
                  </p>
                }
                id={4}
              >
                <div>
                  <p className="flex items-center gap-2">
                    <FiAlertCircle className="text-[20px]" /> Please check all
                    the steps before generating the offer letter.
                  </p>
                  <div className="flex justify-end mt-3 gap-3">
                    {pdfLink?.length > 0 && (
                      <Link
                        to={`${SERVER_URL}/api/v1/file/view/${pdfLink}`}
                        target="_blank"
                      >
                        <ButtonCompo
                          variant={"contained"}
                          onClick={generateOfferLetter}
                        >
                          Download Offer Letter
                        </ButtonCompo>
                      </Link>
                    )}
                    {letterHeadingFlag === true &&
                    letterContentFlag === true ? (
                      <ButtonCompo
                        variant={"contained"}
                        onClick={generateOfferLetter}
                      >
                        generate
                      </ButtonCompo>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </AccrodianBox>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OfferLetter;
